import moment from "moment";
import { HashMapItem, HashMapItems } from "types/MyFlow";

const dayDiff = (date: string): number => {
  let d1 = new Date(date);
  let d2 = new Date();
  let t2 = d2.getTime();
  let t1 = d1.getTime();
  return (t2 - t1) / (24 * 3600 * 1000);
};

export function isNew(date: string): boolean {
  return date && moment(date).isValid() && dayDiff(moment(date).toString()) < 8;
}

export function getVenues(): number[] {
  return [
    14, 38, 15, 35, 40, 302, 41, 183, 206, 284, 286, 81, 36, 49, 345, 359, 379, 393, 398, 429
  ];
}

export function isTagInArray(
  tag: { name: string },
  uniqueTags: { name: string }[]
): boolean {
  for (let i: number = 0; i < uniqueTags.length; i++) {
    if (tag.name === uniqueTags[i].name) {
      return true;
    }
  }
  return false;
}

export function getVenueNameByID(id: number): string {
  let venue: string;
  switch (id) {
    case 14:
      venue = "Main Stage";
      break;
    case 38:
      venue = "Red Arena by Lapin Kulta Pure";
      break;
    case 15:
      venue = "FREE.fi Black Tent";
      break;
    case 35:
      venue = "Balloon 360°";
      break;
    case 40:
      venue = "Resident Advisor Front Yard";
      break;
    case 302:
      venue = "Backyard";
      break;
    case 41:
      venue = "The Other Sound x Sun Effects";
      break;
    case 183:
      venue = "Voimala";
      break;
    case 206:
      venue = "Riviera Cinema Bar";
      break;
    case 284:
      venue = "Red Garden";
      break;
    case 286:
      venue = "Vinyl Market by we Jazz";
      break;
    case 36:
      venue = "Champagne Bar & Lounge";
      break;
    case 49:
      venue = "Family Sunday";
      break;
    case 345:
      venue = "Finnkino Pop-Up Cinema";
      break;
    case 379:
      venue = "Pink Space";
      break;
    case 359:
      venue = "Kansallisooppera, Alminsali";
      break;
    case 393:
      venue = "Tiilikello x Polestar";
      break;
    case 398:
      venue = "Make Your Mark Gallery";
      break;
    case 429:
      venue = "Viinilinna"
          break;
    default:
      venue = "TBA";
  }
  return venue;
}

export const translateVenueName = (langCode: string, name: string): string => {
  if (name === "Ooppera") {
    if (langCode === "fi") {
      return "Kansallisooppera, Alminsali";
    } else {
      return "Finnish National Opera, Almi Hall";
    }
  }
  return name;
};

export type Day = {
  date: string;
  events: HashMapItem[];
};

export const translateItemTypeForNewAPI = (type: string): string => {
  if (type === "artist") {
    return "artists";
  } else if (type === "art_and_design") {
    return "arts";
  } else {
    return type;
  }
};

export const mergeFavourites = (
  a: Favourite[],
  b: Favourite[]
): Favourite[] => {
  const reduced: Favourite[] = a.filter(
    (a_item: Favourite) =>
      !b.find((b_item: Favourite) => a_item.programId === b_item.programId)
  );
  return reduced.concat(b);
};

export const sortEventItemsByDay = (
  items: HashMapItems,
  sortFn?: (a: HashMapItem, b: HashMapItem) => any
): Day[] => {
  const artists = Object.keys(items).map((key) => items[key]);

  let eventsByDay: Day[] = [];

  artists.map((item: HashMapItem) => {
    if (item) {
      let day: Day = eventsByDay.find(
        (day: Day) => day.date === item.event.date
      );
      if (!day) {
        eventsByDay.push({ date: item.event.date, events: [item] });
      } else {
        day.events.push(item);
      }
    }
  });

  let tba = eventsByDay.find((day: Day) => day.date === "tba");
  eventsByDay = eventsByDay.filter((day: Day) => {
    return moment(day.date).isValid();
  });
  eventsByDay.sort((a, b) => {
    return (
      Number(a.date ? a.date.split("-").join("") : 0) -
      Number(b.date ? b.date.split("-").join("") : 0)
    );
  });
  if (tba) {
    eventsByDay.push(tba);
  }

  if (sortFn) {
    eventsByDay.map((day: Day) => {
      day.events.sort(sortFn);
    });
  }

  return eventsByDay;
};

export const filterSelectedEvents = (
  eventIdHashMap: HashMapItems,
  selectedIds: Array<string>
): HashMapItems => {
  return selectedIds.reduce((obj: HashMapItems, hash: string) => {
    obj[hash] = eventIdHashMap[hash];
    return obj;
  }, {});
};

export const groupByKey = function (xs: any, key: string) {
  return xs.reduce(function (rv: any, x: any) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export const sortEventsByTimeASC = (a: HashMapItem, b: HashMapItem): number => {
  return b.event.comparisonValue - a.event.comparisonValue;
};

export const sortEventsByTimeDESC = (
  a: HashMapItem,
  b: HashMapItem
): number => {
  return a.event.comparisonValue - b.event.comparisonValue;
};

export const BASE_PATH = process.env.REACT_BASE_PATH
  ? `/${process.env.REACT_BASE_PATH}`
  : "";

export const getFavouriteById = (
  favourites: Favourite[],
  programId: string
): Favourite | undefined => {
  return favourites.find(
    (favourite: Favourite) => favourite.programId === programId
  );
};



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/utils/helperUtils.ts